import { render, staticRenderFns } from "./SimulationsTable.vue?vue&type=template&id=67a9cf9a&scoped=true&"
import script from "./SimulationsTable.vue?vue&type=script&lang=js&"
export * from "./SimulationsTable.vue?vue&type=script&lang=js&"
import style0 from "./SimulationsTable.vue?vue&type=style&index=0&id=67a9cf9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a9cf9a",
  null
  
)

export default component.exports